import { action } from 'typesafe-actions';

const entity = 'timezone';
const SET_TIMEZONE = `${entity}/SET_TIMEZONE`;

const actionSetTimezone = (timezone?: string) => action(SET_TIMEZONE, timezone);

export { SET_TIMEZONE, actionSetTimezone };
